// src/Inquiry.js
import { Button, Card, Flex, Heading, Input, Message, Text, TextAreaField } from '@aws-amplify/ui-react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import validator from 'validator';

const Inquiry = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const apiBase = useMemo(() => {
    const base = process.env.REACT_APP_API_BASE || '';
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;

    const useProxy = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_PROXY !== 'false';

    return useProxy ? '' : normalizedBase;
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = { email, message };
    const endpoint = `${apiBase}/send`;

    try {
      console.log('[inquiry] sending request', { endpoint, body });
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const payload = await response.json().catch(() => ({}));

      if (response.ok) {
        setEmail('');
        setMessage('');
        setError('');
        console.log('[inquiry] send succeeded', payload);
      } else {
        console.error('[inquiry] send failed', {
          status: response.status,
          statusText: response.statusText,
          payload,
        });
        setError(t('sendError'));
      }
    } catch (error) {
      console.error('[inquiry] network error', error);
      setError(t('sendError'));
    }
  };

  return (
    <Flex direction="column" width="100%">
      <Card>
        <Heading level={4}>{t('inquiryForm')}</Heading>
        <Text>{t('inquiryDescription')}</Text>
      </Card>

      <Card>
        <Text>Email:</Text>
        <Input
          type="email"
          name="email"
          value={email}
          required
          width={'50%'}
          onChange={(e) => setEmail(e.target.value)}
          onBlur={() => setError(validator.isEmail(email) ? '' : t('invalidEmail'))}
        />
      </Card>

      <Card>
        <TextAreaField
          label={`${t('yourInquiryIs')}:`}
          name="message"
          value={message}
          required
          width={'100%'}
          rows={5}
          maxLength={1000}
          onChange={(e) => setMessage(e.target.value)}
        />
      </Card>

      <Card>
        <Button variation="primary" isDisabled={email === '' || message === ''} onClick={handleSubmit}>
          Send
        </Button>
      </Card>

      {error ? (
        <Card>
          <Message colorTheme="error">{error}</Message>
        </Card>
      ) : null}
    </Flex>
  );
};

export default Inquiry;
